module.exports = {
	"header": "Subscription",
	"addMore": "If you want to add more, you will need to upgrade your subscription.",
	"downgradeConfirmation": "Are you sure you want to downgrade now?",
	"downgradePlan": "Downgrade plan",
	"expiresOn": "Expires On",
	"immediatePlanChanges": "Plan changes are immediate.",
	"lotsPerAuction": "Lots per auction",
	"nextRenewal": "Next renewal on",
	"picturesPerLot": "Pictures per lot",
	"plan": "Plan",
	"pricing": "Pricing",
	"switchMonthly": "Switch to monthly billing",
	"switchYearly": "Switch to yearly billing",
	"updated": "Subscription successfully updated.",
	"update": "Update subscription.",
	"upgradeSubscriptionLink": "You can see available subscription upgrades <subscriptionLink>$t(general::here)</subscriptionLink>.",
	"yourPlan": "Your plan"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/subscription.json5
// module id = 1959
// module chunks = 6